import UploadFileType from "./enums/UploadFileType";

class UploadRequest {
  constructor(
    public file_name: string,
    public file_checksum: string,
    public file_type: UploadFileType,
    public total_chunks: number
  ) {}
}

export default UploadRequest;
